<template>
  <div id="app">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="nav-brand">VX电竞馆</div>
      <div class="nav-links">
        <a href="#home">首页</a>
        <a href="#equipment">设备</a>
       <!-- <a href="#events">赛事</a>-->
       <!-- <a href="#price">价格</a>-->
        <a href="#about">关于我们</a>
      </div>
    </nav>

    <!-- 主要内容区域 -->
    <main>
      <!-- Hero区域 -->
      <section class="hero">
        <div class="hero-content">
          <h1>VX电竞馆</h1>
          <p>专业的电竞体验，尽在于此</p>
          <!-- <button class="cta-button">立即预约</button> -->
        </div>
      </section>

      <!-- 设备展示区 -->
      <section class="equipment" id="equipment">
        <h2>顶级电竞装备</h2>
        <div class="equipment-grid">
          <div class="equipment-card">
            <i class="fas fa-desktop"></i>
            <h3>顶级主机</h3>
            <p>RTX3090 + i9 12900K</p>
          </div>
          <div class="equipment-card">
            <i class="fas fa-tv"></i>
            <h3>专业显示器</h3>
            <p>240Hz 电竞显示器</p>
          </div>
          <div class="equipment-card">
            <i class="fas fa-keyboard"></i>
            <h3>专业外设</h3>
            <p>机械键盘 + 专业鼠标</p>
          </div>
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="footer-content">
       <!--   <div class="footer-section">
          <h3>联系我们</h3>
          <p>地址：某某市某某区某某街123号</p>
          <p>电话：123-456-7890</p>
        </div>
        <div class="footer-section">
          <h3>营业时间</h3>
          <p>周一至周五：10:00 - 24:00</p>
          <p>周六日：24小时营业</p>
        </div> -->
      </div>
      <div class="footer-bottom">
        <p>&copy; 2024 VX电竞馆 版权所有</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Arial', sans-serif;
  background: #0a0a0a;
  color: white;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 导航栏样式 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 1rem 2rem;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
}

.nav-brand {
  font-size: 1.5rem;
  font-weight: bold;
  color: #00f;
}

.nav-links a {
  color: white;
  text-decoration: none;
  margin-left: 2rem;
  transition: color 0.3s ease;
}

.nav-links a:hover {
  color: #00f;
}

/* Hero区域样式 */
.hero {
  height: 100vh;
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
              url('./assets/hero-bg.svg') center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 1rem;
}

.hero-content h1 {
  font-size: 4rem;
  margin-bottom: 1rem;
  color: #fff;
  text-shadow: 0 0 10px rgba(0, 0, 255, 0.5);
}

.hero-content p {
  font-size: 1.5rem;
  margin-bottom: 2rem;
}

.cta-button {
  padding: 1rem 2rem;
  font-size: 1.2rem;
  background: #00f;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.cta-button:hover {
  transform: scale(1.05);
}

/* 设备展示区样式 */
.equipment {
  padding: 4rem 2rem;
  background: #111;
}

.equipment h2 {
  text-align: center;
  margin-bottom: 3rem;
  color: #00f;
}

.equipment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.equipment-card {
  background: #1a1a1a;
  padding: 2rem;
  text-align: center;
  border-radius: 10px;
  transition: transform 0.3s ease;
}

.equipment-card:hover {
  transform: translateY(-10px);
}

.equipment-card i {
  font-size: 3rem;
  color: #00f;
  margin-bottom: 1rem;
}

/* 页脚样式 */
.footer {
  background: #111;
  padding: 3rem 2rem 1rem;
  margin-top: auto;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-section h3 {
  color: #00f;
  margin-bottom: 1rem;
}

.footer-bottom {
  text-align: center;
  padding-top: 2rem;
  margin-top: 2rem;
  border-top: 1px solid #333;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

</style>
